import { useEffect, useState } from 'react';
import { apiErrorHandling } from '../api/apierrorhandling';
import { generalStore } from '../stores/GeneralStore';
import { getRevenuePools } from '../api/stoApi';
import { TRevenuePool } from '../models';
import { UseTranslationResponse } from 'react-i18next';

export const useRevenuePools = (
  filters: {
    page?: number;
    rowsPerPage?: number;
    title?: string;
  },
  t: UseTranslationResponse<any>,
) => {
  const [revenuePools, setRevenuePools] = useState<{ items: TRevenuePool[]; count: number }>({ items: [], count: 0 });
  const load = async () => {
    generalStore.setIsLoading(true);
    try {
      const response = (await getRevenuePools(filters)).data;
      setRevenuePools(response.data);
    } catch (error: any) {
      apiErrorHandling(error, t('revenuePools.errors.loadAll'));
    } finally {
      generalStore.setIsLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [filters.page, filters.rowsPerPage, filters.title]);

  return revenuePools;
};
